import { useMutation, useQueryClient } from '@tanstack/react-query';
import { activateProduct, deactivateProduct } from '../services/products.api';

interface ToggleProductVariables {
  id: string;
  activate: boolean;
  force?: boolean;
}

export function useActivateProduct() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, activate, force }: ToggleProductVariables) =>
      activate ? activateProduct(id) : deactivateProduct(id, force),
    onSuccess: (product) => {
      void queryClient.invalidateQueries({ queryKey: ['products', 'list'] });
      void queryClient.invalidateQueries({ queryKey: ['products', 'detail', product.id] });
    },
  });
}
